@if (capabilitySpec$ | async; as capability) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: capability }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: capability }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="capabilitySpecTab">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}">
          <elder-basic-pane-layout class="full">
            <!-- General -->
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button
                    mat-icon-button
                    [disabled]="!mainFrm.form.valid || (actionSequence$ | async).length === 0"
                    (click)="onSave($event)"
                  >
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                      <mat-icon>delete</mat-icon>
                      <span>{{ 'actions.delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content>
                <form #mainFrm="ngForm" class="flex full layout-row gap-xl">
                  <div class="flex layout-col">
                    <div class="layout-row">
                      <div class="flex layout-col">
                        <!-- Identifications -->
                        <elder-pane-subtitle>{{
                          'context.identification' | translate
                        }}</elder-pane-subtitle>
                        <div class="layout-col gap-md">
                          <mat-form-field class="flex">
                            <mat-label>{{ 'context.name' | translate }}</mat-label>
                            <input
                              matInput
                              name="name"
                              required
                              placeholder="{{ 'context.name' | translate }}"
                              [(ngModel)]="capability.name"
                            />
                          </mat-form-field>
                          <mat-form-field class="flex">
                            <mat-label>{{ 'context.description' | translate }}</mat-label>
                            <input
                              matInput
                              name="description"
                              placeholder="{{ 'context.description' | translate }}"
                              [(ngModel)]="capability.description"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex layout-col">
                    <div class="flex layout-row gap-xl">
                      <!-- Operations -->
                      <div class="flex layout-col">
                        <elder-pane-subtitle>{{
                          'process.actions.title' | translate
                        }}</elder-pane-subtitle>
                        <div class="flex layout-row gap-md">
                          <elder-table
                            class="flex"
                            [data]="actionSequence$ | async"
                            [selectionMultiEnabled]="true"
                            [selectionVisible]="true"
                          >
                            <elder-data-toolbar
                              *elderTableToolbar
                              [canMore]="false"
                              [canAdd]="false"
                              [canRemove]="true"
                              (requestRemove)="onRemoveActions($event)"
                            >
                              <ng-template [elderToolbarContent]="'left'">
                                <mat-form-field subscriptSizing="dynamic">
                                  <elder-select
                                    name="addOperation"
                                    appActionSelect
                                    placeholder="{{ 'process.actions.add' | translate }}"
                                    (valueChange)="onAddAction($event)"
                                    [disabledWorkActions]="actionSequence$ | async"
                                  >
                                    <div *elderSelectValue="let value" class="layout-col">
                                      <span style="line-height: 20px">{{ value.name }}</span>
                                      <span class="mat-caption">{{ value.id }}</span>
                                    </div>
                                  </elder-select>
                                </mat-form-field>
                              </ng-template>
                            </elder-data-toolbar>
                            <!-- id Column -->
                            <ng-container matColumnDef="id">
                              <th mat-header-cell *matHeaderCellDef>
                                {{ 'context.id' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let operation">{{ operation.action }}</td>
                            </ng-container>
                            <!-- order controls -->
                            <ng-container matColumnDef="actionOrder">
                              <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                              <td mat-cell *matCellDef="let op">
                                <div class="place-start-center">
                                  <button
                                    mat-icon-button
                                    (click)="moveUp(op)"
                                    elderStopEventPropagation
                                  >
                                    <mat-icon>arrow_drop_up</mat-icon>
                                  </button>
                                  <button
                                    mat-icon-button
                                    (click)="moveDown(op)"
                                    elderStopEventPropagation
                                  >
                                    <mat-icon>arrow_drop_down</mat-icon>
                                  </button>
                                </div>
                              </td>
                            </ng-container>
                          </elder-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab Skill Sets -->
        <mat-tab label="{{ 'skillSets.skillSets' | translate }}">
          <elder-basic-pane-layout class="full">
            <!-- General -->
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                      <mat-icon>delete</mat-icon>
                      <span>{{ 'actions.delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content>
                <form #skillSetFrm="ngForm" class="flex full layout-row gap-xl">
                  <div class="flex-30 layout-col">
                    <div class="flex layout-row gap-xl">
                      <!-- Skill Sets -->
                      <div class="flex layout-col">
                        <elder-pane-subtitle>{{
                          'skillSets.skillSets' | translate
                        }}</elder-pane-subtitle>
                        <elder-table
                          class="flex outlined"
                          [data]="skillSetSpecs$ | async"
                          [selectionMultiEnabled]="true"
                          [selectionVisible]="true"
                          (itemClick)="onSkillSetClick($event)"
                        >
                          <elder-data-toolbar
                            *elderTableToolbar
                            [canMore]="false"
                            [canAdd]="true"
                            [canRemove]="true"
                            (requestNew)="onNewSkillSetSpec($event)"
                            (requestRemove)="onRemoveSkillSetSpecs($event)"
                          >
                          </elder-data-toolbar>
                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'context.name' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let spec">{{ spec.name }}</td>
                          </ng-container>
                          <ng-container matColumnDef="conditions">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'skillSets.conditions.title' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let spec">{{ spec.conditions?.length }}</td>
                          </ng-container>
                          <ng-container matColumnDef="constraints">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'skillSets.constraints.title' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let spec">{{ spec.constraints?.length }}</td>
                          </ng-container>
                          <ng-container matColumnDef="capacities">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'skillSets.capacities.title' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let spec">{{ spec.capacities?.length }}</td>
                          </ng-container>
                        </elder-table>
                      </div>
                    </div>
                  </div>
                  <div class="flex layout-col">
                    <app-skill-set-spec-detail
                      class="flex"
                      [skillSetSpec]="selectedSkillSet$ | async"
                    >
                    </app-skill-set-spec-detail>
                  </div>
                </form>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<ng-template #header let-capabilitySpec>
  @if (creationMode) {
    <span>
      {{ 'capabilities.new' | translate }}
    </span>
  } @else {
    <elder-header
      [header]="'capabilities.capability' | translate"
      [subheader]="'ID: ' + capabilitySpec.id"
    >
    </elder-header>
  }
</ng-template>
